import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-300/60"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          title={article.title}
        />
        {article.featured && (
          <span className="absolute top-3 left-3 px-2 py-1 bg-accent-500 text-white text-xs font-medium rounded-md">
            精选
          </span>
        )}
        <div className="absolute top-3 right-3 px-2 py-1 bg-foreground-950/60 text-white text-xs rounded-md flex items-center gap-1">
          <i className="ri-star-fill text-yellow-400 text-xs"></i>
          {article.rating}
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          {article.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 bg-secondary-100 text-secondary-800 text-xs rounded-md"
            >
              {tag}
            </span>
          ))}
        </div>
        <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i> {article.publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i> {article.readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}